.custom_logo {
  object-fit: contain;
}


// a school without a logo: its name in the header instead of the platform logo
.school_name {
  overflow: hidden;

  max-width: 240px;

  font-size: var(--axl-text-lg);
  font-weight: 700;
  color: currentcolor;
  text-overflow: ellipsis;
  white-space: nowrap;
}
